module.exports = __webpack_public_path__ + "img/chantier-full.59662bea.jpg";